export default {
  methods: {
    onImageLoad(_ev) {
      const ev = _ev;
      ev.target.sizes = `${Math.ceil(
        (ev.target.getBoundingClientRect().width / window.innerWidth) * 100
      )}vw`;
    },
  },
};
